export default __webpack_public_path__ + "static/media/usd.ae1267bc.png";